import { surgeonsConstants } from '../constants';
import {List} from "immutable";

export function surgeons(state = {}, action) {
  switch (action.type) {
    case surgeonsConstants.GETSURGEONS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        data: new List()
      });
    case surgeonsConstants.GETSURGEONS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.data
      });
    case surgeonsConstants.GETSURGEONS_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.error
      });
    default:
      return state
  }
}
